/**
 * Roles reales de la plataforma (`enum Rol` en Prisma). La comunidad los
 * muestra: saber si quien responde es otro paciente, un familiar, un
 * profesional o la administración es la diferencia entre un foro y un
 * coro de iguales.
 */
export type RolComunidad = 'ESTUDIANTE' | 'PSICOLOGO' | 'PADRE' | 'ADMIN';

export interface UsuarioComunidad {
  id: number;
  nombre: string;
  avatar?: string | null;
  /** El backend lo incluye desde el cambio del repositorio; si no llega, la
   *  insignia muestra "Participante" en vez de inventar un rol. */
  rol?: RolComunidad | null;
}

export interface Comentario {
  id: number;
  postId: number;
  usuarioId: number;
  usuario?: UsuarioComunidad | null;
  contenido: string;
  fecha: string;
  /** `null` = respuesta de primer nivel; con id = respuesta a otra. */
  parentId?: number | null;
}

export interface PostComunidad {
  id: number;
  usuarioId: number;
  usuario?: UsuarioComunidad | null;
  titulo: string;
  contenido: string;
  categoria: string;
  fecha: string;
  estadoModeracion: 'APROBADO' | 'PENDIENTE' | 'RECHAZADO';
  likes: number;
  reportado: boolean;
  reportadoCount: number;
  /**
   * Hilo completo. Solo viene al pedir un post suelto (`getPost`): la
   * lista de posts trae `_count`, no las respuestas.
   */
  comentarios?: Comentario[];
  /**
   * Numero REAL de respuestas. Antes la lista traia `comentarios: take 3`
   * y la tarjeta contaba eso: un post con 12 respuestas decia "3".
   */
  _count?: { comentarios: number };
}

export interface PostDTO {
  titulo: string;
  contenido: string;
  categoria: string;
}

export interface ComentarioDTO {
  postId: number;
  contenido: string;
  parentId?: number;
}

/** Errores del backend: los mensajes que explican un rechazo real
 *  ("no tienes un profesional asignado en INTUS") se muestran tal cual. */
export function mensajeDeError(error: unknown, porDefecto: string): string {
  const backend = (error as { response?: { data?: { error?: string } } } | null)?.response?.data?.error;
  return typeof backend === 'string' && backend.length > 0 ? backend : porDefecto;
}
